// client/text-to-speech.ts
var context = null;
var buf;
function initLazy() {
  if (!context) {
    context = new AudioContext();
  }
}
function playByteArray(byteArray) {
  initLazy();
  if (!context) {
    throw new Error("AudioContext is not initialized");
  }
  const arrayBuffer = new ArrayBuffer(byteArray.length);
  const bufferView = new Uint8Array(arrayBuffer);
  for (let i = 0; i < byteArray.length; i++) {
    const val = byteArray[i];
    if (val === void 0)
      throw new Error("Array had not the same length as .length. If this happens destroy the universe!");
    bufferView[i] = val;
  }
  context.decodeAudioData(arrayBuffer, function(buffer) {
    buf = buffer;
    play();
  });
}
function play() {
  initLazy();
  if (!context) {
    throw new Error("AudioContext is not initialized");
  }
  const source = context.createBufferSource();
  source.buffer = buf;
  source.connect(context.destination);
  source.start(0);
}
async function textToSpeech(text) {
  const url = `/proxy/speech/text-to-speech`;
  const params = new URLSearchParams();
  params.append("input", text);
  const rawResponse = await fetch(url + "?" + params.toString());
  if (rawResponse.status !== 200)
    throw new Error("Fetch to audio api went wrong " + rawResponse.statusText);
  const response = await rawResponse.json();
  playByteArray(response.audio.data);
}
export {
  textToSpeech
};
